export default __webpack_public_path__ + "static/media/avatar_17.c421a11e.svg";